/**
 * Esprima Studios — Engraving Options Config
 * -------------------------------------------
 * Source of truth for per-SKU engraving constraints, sourced from the
 * confirmed Stuller.com research in SOP_Shopify_to_Stuller_Engraving_Fulfillment.md
 * (SKU reference sheet, confirmed live on Stuller.com 2026-07-13).
 *
 * Keyed by the Shopify VARIANT SKU (not the Stuller item #), so the
 * front-end module (engraving-options.js) can look up a piece's engraving
 * rules directly from the variant the buyer is currently viewing.
 *
 * REGENERATED 2026-07-15 by the source-of-truth chain audit: the 2026-07-13/14
 * placeholder SKUs below (V01-PR-*, V01-IC-NK-003, V01-IC-PD-005) were retired
 * when Presence and Iconic were rebuilt from the full Stuller variant feeds —
 * each old single-variant placeholder is now N real Stuller variant SKUs, so
 * every variant of an engravable product needs its own entry (the lookup in
 * engraving-options.js is an exact SKU match, no prefix logic). Also added the
 * previously-unmapped Stuller #88225 (Engravable Disc Charm/Pendant), which
 * went live this same session.
 *
 * To add a newly-published engravable product: find its Shopify variant
 * SKU(s) in Admin > Products, add one entry per variant below, and pull
 * the location/character-limit/type values from Stuller's product page
 * under "Customization Options" (do not guess — limits vary piece to piece).
 * Then re-run audit_stuller_chain.py --check-modules to confirm no gaps.
 */
window.EsprimaEngravingConfig = {
  "V01-AX-NK-001": {
    stullerItem: "87619",
    productName: "Engravable Four-Sided Bar Necklace",
    locations: [
      { id: "front", label: "Front", maxLength: 12 },
      { id: "left", label: "Left Side", maxLength: 12 },
      { id: "right", label: "Right Side", maxLength: 12 },
      { id: "back", label: "Back", maxLength: 12 }
    ],
    engravingTypes: ["text", "handwritten"],
    fonts: ["Bookman Horizontal"],
    defaultFont: "Bookman Horizontal",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Only piece with 4 engraving locations. 12-character limit confirmed on Front only — the other 3 sides are assumed identical but were not individually re-checked on Stuller; verify before relying on it for a large order. STILL A PLACEHOLDER SKU as of 2026-07-15 — Axis collection has not yet been rebuilt from the full Stuller feed; re-key this once it is."
  },
  "88759:100:P": { stullerItem: "88759", productName: "Engravable Sunburst Necklace", locations: [{ id: "front", label: "Front", maxLength: 1 }], engravingTypes: ["text"], fonts: ["Bookman Old Style"], defaultFont: "Bookman Old Style", colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"], defaultColor: "None", notes: "GAP CLOSED 2026-07-16 — NEWLY MAPPED, settings NOT individually re-confirmed on Stuller.com yet (Front-only/1-char/laser-only carried over from the other single-disc Engravable Disc items as a placeholder assumption). Verify against item 88759's own Customization Options before relying on this for a large order." },
  "88759:101:P": { stullerItem: "88759", productName: "Engravable Sunburst Necklace", locations: [{ id: "front", label: "Front", maxLength: 1 }], engravingTypes: ["text"], fonts: ["Bookman Old Style"], defaultFont: "Bookman Old Style", colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"], defaultColor: "None", notes: "GAP CLOSED 2026-07-16 — NEWLY MAPPED, settings NOT individually re-confirmed on Stuller.com yet. Verify against item 88759's own Customization Options before relying on this for a large order." },
  "88759:102:P": { stullerItem: "88759", productName: "Engravable Sunburst Necklace", locations: [{ id: "front", label: "Front", maxLength: 1 }], engravingTypes: ["text"], fonts: ["Bookman Old Style"], defaultFont: "Bookman Old Style", colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"], defaultColor: "None", notes: "GAP CLOSED 2026-07-16 — NEWLY MAPPED, settings NOT individually re-confirmed on Stuller.com yet. Verify against item 88759's own Customization Options before relying on this for a large order." },
  "88759:103:P": { stullerItem: "88759", productName: "Engravable Sunburst Necklace", locations: [{ id: "front", label: "Front", maxLength: 1 }], engravingTypes: ["text"], fonts: ["Bookman Old Style"], defaultFont: "Bookman Old Style", colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"], defaultColor: "None", notes: "GAP CLOSED 2026-07-16 — NEWLY MAPPED, settings NOT individually re-confirmed on Stuller.com yet. Verify against item 88759's own Customization Options before relying on this for a large order." },
  "88759:104:P": { stullerItem: "88759", productName: "Engravable Sunburst Necklace", locations: [{ id: "front", label: "Front", maxLength: 1 }], engravingTypes: ["text"], fonts: ["Bookman Old Style"], defaultFont: "Bookman Old Style", colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"], defaultColor: "None", notes: "GAP CLOSED 2026-07-16 — NEWLY MAPPED, settings NOT individually re-confirmed on Stuller.com yet. Verify against item 88759's own Customization Options before relying on this for a large order." },
  "88759:105:P": { stullerItem: "88759", productName: "Engravable Sunburst Necklace", locations: [{ id: "front", label: "Front", maxLength: 1 }], engravingTypes: ["text"], fonts: ["Bookman Old Style"], defaultFont: "Bookman Old Style", colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"], defaultColor: "None", notes: "GAP CLOSED 2026-07-16 — NEWLY MAPPED, settings NOT individually re-confirmed on Stuller.com yet. Verify against item 88759's own Customization Options before relying on this for a large order." },
  "88759:106:P": { stullerItem: "88759", productName: "Engravable Sunburst Necklace", locations: [{ id: "front", label: "Front", maxLength: 1 }], engravingTypes: ["text"], fonts: ["Bookman Old Style"], defaultFont: "Bookman Old Style", colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"], defaultColor: "None", notes: "GAP CLOSED 2026-07-16 — NEWLY MAPPED, settings NOT individually re-confirmed on Stuller.com yet. Verify against item 88759's own Customization Options before relying on this for a large order." },
  "88759:107:P": { stullerItem: "88759", productName: "Engravable Sunburst Necklace", locations: [{ id: "front", label: "Front", maxLength: 1 }], engravingTypes: ["text"], fonts: ["Bookman Old Style"], defaultFont: "Bookman Old Style", colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"], defaultColor: "None", notes: "GAP CLOSED 2026-07-16 — NEWLY MAPPED, settings NOT individually re-confirmed on Stuller.com yet. Verify against item 88759's own Customization Options before relying on this for a large order." },
  "88759:108:P": { stullerItem: "88759", productName: "Engravable Sunburst Necklace", locations: [{ id: "front", label: "Front", maxLength: 1 }], engravingTypes: ["text"], fonts: ["Bookman Old Style"], defaultFont: "Bookman Old Style", colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"], defaultColor: "None", notes: "GAP CLOSED 2026-07-16 — NEWLY MAPPED, settings NOT individually re-confirmed on Stuller.com yet. Verify against item 88759's own Customization Options before relying on this for a large order." },
  "88759:109:P": { stullerItem: "88759", productName: "Engravable Sunburst Necklace", locations: [{ id: "front", label: "Front", maxLength: 1 }], engravingTypes: ["text"], fonts: ["Bookman Old Style"], defaultFont: "Bookman Old Style", colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"], defaultColor: "None", notes: "GAP CLOSED 2026-07-16 — NEWLY MAPPED, settings NOT individually re-confirmed on Stuller.com yet. Verify against item 88759's own Customization Options before relying on this for a large order." },
  "87619:120:P": {
    stullerItem: "87619",
    productName: "Engravable Four-Sided Bar Necklace (Layered Expression, Sterling Silver)",
    locations: [
      { id: "front", label: "Front", maxLength: 12 },
      { id: "left", label: "Left Side", maxLength: 12 },
      { id: "right", label: "Right Side", maxLength: 12 },
      { id: "back", label: "Back", maxLength: 12 }
    ],
    engravingTypes: ["text", "handwritten"],
    fonts: ["Bookman Horizontal"],
    defaultFont: "Bookman Horizontal",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Same physical Stuller item (87619) as the still-placeholder Axis gold version (V01-AX-NK-001) — settings carried over from that confirmed research. NEWLY MAPPED 2026-07-15/16 when the Layered Expression Sterling Silver listing was rebuilt from the real Stuller feed row (87619:120:P). Only piece with 4 engraving locations; 12-character limit confirmed on Front only — the other 3 sides are assumed identical but were not individually re-checked on Stuller."
  },
  "85774:1001:P": {
    stullerItem: "85774",
    productName: "Be Posh® Engravable Disc Pendant",
    locations: [
      { id: "front", label: "Front", maxLength: 3 },
      { id: "back", label: "Back", maxLength: 3 }
    ],
    engravingTypes: ["text", "handwritten"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Confirmed live on Stuller.com 2026-07-13."
  },
  "85774:1002:P": {
    stullerItem: "85774",
    productName: "Be Posh® Engravable Disc Pendant",
    locations: [
      { id: "front", label: "Front", maxLength: 3 },
      { id: "back", label: "Back", maxLength: 3 }
    ],
    engravingTypes: ["text", "handwritten"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Confirmed live on Stuller.com 2026-07-13."
  },
  "85774:1003:P": {
    stullerItem: "85774",
    productName: "Be Posh® Engravable Disc Pendant",
    locations: [
      { id: "front", label: "Front", maxLength: 3 },
      { id: "back", label: "Back", maxLength: 3 }
    ],
    engravingTypes: ["text", "handwritten"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Confirmed live on Stuller.com 2026-07-13."
  },
  "85774:1005:P": {
    stullerItem: "85774",
    productName: "Be Posh® Engravable Disc Pendant",
    locations: [
      { id: "front", label: "Front", maxLength: 3 },
      { id: "back", label: "Back", maxLength: 3 }
    ],
    engravingTypes: ["text", "handwritten"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Confirmed live on Stuller.com 2026-07-13."
  },
  "85774:1006:P": {
    stullerItem: "85774",
    productName: "Be Posh® Engravable Disc Pendant",
    locations: [
      { id: "front", label: "Front", maxLength: 3 },
      { id: "back", label: "Back", maxLength: 3 }
    ],
    engravingTypes: ["text", "handwritten"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Confirmed live on Stuller.com 2026-07-13."
  },
  "85774:1007:P": {
    stullerItem: "85774",
    productName: "Be Posh® Engravable Disc Pendant",
    locations: [
      { id: "front", label: "Front", maxLength: 3 },
      { id: "back", label: "Back", maxLength: 3 }
    ],
    engravingTypes: ["text", "handwritten"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Confirmed live on Stuller.com 2026-07-13."
  },
  "85774:1009:P": {
    stullerItem: "85774",
    productName: "Be Posh® Engravable Disc Pendant",
    locations: [
      { id: "front", label: "Front", maxLength: 3 },
      { id: "back", label: "Back", maxLength: 3 }
    ],
    engravingTypes: ["text", "handwritten"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Confirmed live on Stuller.com 2026-07-13."
  },
  "85774:1010:P": {
    stullerItem: "85774",
    productName: "Be Posh® Engravable Disc Pendant",
    locations: [
      { id: "front", label: "Front", maxLength: 3 },
      { id: "back", label: "Back", maxLength: 3 }
    ],
    engravingTypes: ["text", "handwritten"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Confirmed live on Stuller.com 2026-07-13."
  },
  "85774:1011:P": {
    stullerItem: "85774",
    productName: "Be Posh® Engravable Disc Pendant",
    locations: [
      { id: "front", label: "Front", maxLength: 3 },
      { id: "back", label: "Back", maxLength: 3 }
    ],
    engravingTypes: ["text", "handwritten"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Confirmed live on Stuller.com 2026-07-13."
  },
  "85774:1012:P": {
    stullerItem: "85774",
    productName: "Be Posh® Engravable Disc Pendant",
    locations: [
      { id: "front", label: "Front", maxLength: 3 },
      { id: "back", label: "Back", maxLength: 3 }
    ],
    engravingTypes: ["text", "handwritten"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Confirmed live on Stuller.com 2026-07-13."
  },
  "85774:1014:P": {
    stullerItem: "85774",
    productName: "Be Posh® Engravable Disc Pendant",
    locations: [
      { id: "front", label: "Front", maxLength: 3 },
      { id: "back", label: "Back", maxLength: 3 }
    ],
    engravingTypes: ["text", "handwritten"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Confirmed live on Stuller.com 2026-07-13."
  },
  "85774:1016:P": {
    stullerItem: "85774",
    productName: "Be Posh® Engravable Disc Pendant",
    locations: [
      { id: "front", label: "Front", maxLength: 3 },
      { id: "back", label: "Back", maxLength: 3 }
    ],
    engravingTypes: ["text", "handwritten"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Confirmed live on Stuller.com 2026-07-13."
  },
  "88331:100:P": {
    stullerItem: "88331",
    productName: "Engravable Disc Necklace or Pendant",
    locations: [
      { id: "front", label: "Front", maxLength: 3 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Laser engraving only — no Text/Handwritten toggle on Stuller. Same physical disc used for both the slide pendant and necklace listing."
  },
  "88331:101:P": {
    stullerItem: "88331",
    productName: "Engravable Disc Necklace or Pendant",
    locations: [
      { id: "front", label: "Front", maxLength: 3 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Laser engraving only — no Text/Handwritten toggle on Stuller. Same physical disc used for both the slide pendant and necklace listing."
  },
  "88331:102:P": {
    stullerItem: "88331",
    productName: "Engravable Disc Necklace or Pendant",
    locations: [
      { id: "front", label: "Front", maxLength: 3 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Laser engraving only — no Text/Handwritten toggle on Stuller. Same physical disc used for both the slide pendant and necklace listing."
  },
  "88331:103:P": {
    stullerItem: "88331",
    productName: "Engravable Disc Necklace or Pendant",
    locations: [
      { id: "front", label: "Front", maxLength: 3 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Laser engraving only — no Text/Handwritten toggle on Stuller. Same physical disc used for both the slide pendant and necklace listing."
  },
  "88331:104:P": {
    stullerItem: "88331",
    productName: "Engravable Disc Necklace or Pendant",
    locations: [
      { id: "front", label: "Front", maxLength: 3 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Laser engraving only — no Text/Handwritten toggle on Stuller. Same physical disc used for both the slide pendant and necklace listing."
  },
  "88331:106:P": {
    stullerItem: "88331",
    productName: "Engravable Disc Necklace or Pendant",
    locations: [
      { id: "front", label: "Front", maxLength: 3 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Laser engraving only — no Text/Handwritten toggle on Stuller. Same physical disc used for both the slide pendant and necklace listing."
  },
  "88331:107:P": {
    stullerItem: "88331",
    productName: "Engravable Disc Necklace or Pendant",
    locations: [
      { id: "front", label: "Front", maxLength: 3 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Laser engraving only — no Text/Handwritten toggle on Stuller. Same physical disc used for both the slide pendant and necklace listing."
  },
  "88331:108:P": {
    stullerItem: "88331",
    productName: "Engravable Disc Necklace or Pendant",
    locations: [
      { id: "front", label: "Front", maxLength: 3 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Laser engraving only — no Text/Handwritten toggle on Stuller. Same physical disc used for both the slide pendant and necklace listing."
  },
  "88331:109:P": {
    stullerItem: "88331",
    productName: "Engravable Disc Necklace or Pendant",
    locations: [
      { id: "front", label: "Front", maxLength: 3 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Laser engraving only — no Text/Handwritten toggle on Stuller. Same physical disc used for both the slide pendant and necklace listing."
  },
  "88331:110:P": {
    stullerItem: "88331",
    productName: "Engravable Disc Necklace or Pendant",
    locations: [
      { id: "front", label: "Front", maxLength: 3 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Laser engraving only — no Text/Handwritten toggle on Stuller. Same physical disc used for both the slide pendant and necklace listing."
  },
  "88265:100:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:101:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:102:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:103:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:104:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:105:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:106:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:107:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:108:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:109:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:110:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:111:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:112:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:113:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:114:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:115:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:116:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:117:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:118:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:119:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:120:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:121:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:122:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:123:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:124:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:125:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:126:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:127:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:128:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:129:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:130:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:131:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:132:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:133:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:134:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:135:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:136:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:137:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:138:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:139:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:140:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:141:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:142:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:143:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:144:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:145:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:146:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:147:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:148:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:149:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:150:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:151:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:152:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:153:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:154:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:155:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:156:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:157:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:158:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:159:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:160:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:161:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:162:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:163:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:164:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:165:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:166:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:167:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:168:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:169:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:170:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "88265:171:P": {
    stullerItem: "88265",
    productName: "Engravable Disc Stud Earrings",
    locations: [
      { id: "customization", label: "Customization", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Single \"Customization\" location, laser engraving only. Stuller also lists a separate \"Special Finishes\" add-on on this item — that is unrelated to engraving and is not represented here."
  },
  "86491:600:P": {
    stullerItem: "86491",
    productName: "Engravable Starburst Necklace",
    locations: [
      { id: "front", label: "Front", maxLength: 1 }
    ],
    engravingTypes: ["text", "handwritten"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Made To Order on Stuller — a 7-day Stuller lead time already applies to this piece, separate from and in addition to engraving's own \"Ship Date May Change\" delay."
  },
  "86491:601:P": {
    stullerItem: "86491",
    productName: "Engravable Starburst Necklace",
    locations: [
      { id: "front", label: "Front", maxLength: 1 }
    ],
    engravingTypes: ["text", "handwritten"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Made To Order on Stuller — a 7-day Stuller lead time already applies to this piece, separate from and in addition to engraving's own \"Ship Date May Change\" delay."
  },
  "86491:602:P": {
    stullerItem: "86491",
    productName: "Engravable Starburst Necklace",
    locations: [
      { id: "front", label: "Front", maxLength: 1 }
    ],
    engravingTypes: ["text", "handwritten"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Made To Order on Stuller — a 7-day Stuller lead time already applies to this piece, separate from and in addition to engraving's own \"Ship Date May Change\" delay."
  },
  "86491:603:P": {
    stullerItem: "86491",
    productName: "Engravable Starburst Necklace",
    locations: [
      { id: "front", label: "Front", maxLength: 1 }
    ],
    engravingTypes: ["text", "handwritten"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Made To Order on Stuller — a 7-day Stuller lead time already applies to this piece, separate from and in addition to engraving's own \"Ship Date May Change\" delay."
  },
  "86491:604:P": {
    stullerItem: "86491",
    productName: "Engravable Starburst Necklace",
    locations: [
      { id: "front", label: "Front", maxLength: 1 }
    ],
    engravingTypes: ["text", "handwritten"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Made To Order on Stuller — a 7-day Stuller lead time already applies to this piece, separate from and in addition to engraving's own \"Ship Date May Change\" delay."
  },
  "86491:605:P": {
    stullerItem: "86491",
    productName: "Engravable Starburst Necklace",
    locations: [
      { id: "front", label: "Front", maxLength: 1 }
    ],
    engravingTypes: ["text", "handwritten"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Made To Order on Stuller — a 7-day Stuller lead time already applies to this piece, separate from and in addition to engraving's own \"Ship Date May Change\" delay."
  },
  "86491:606:P": {
    stullerItem: "86491",
    productName: "Engravable Starburst Necklace",
    locations: [
      { id: "front", label: "Front", maxLength: 1 }
    ],
    engravingTypes: ["text", "handwritten"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Made To Order on Stuller — a 7-day Stuller lead time already applies to this piece, separate from and in addition to engraving's own \"Ship Date May Change\" delay."
  },
  "86491:607:P": {
    stullerItem: "86491",
    productName: "Engravable Starburst Necklace",
    locations: [
      { id: "front", label: "Front", maxLength: 1 }
    ],
    engravingTypes: ["text", "handwritten"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Made To Order on Stuller — a 7-day Stuller lead time already applies to this piece, separate from and in addition to engraving's own \"Ship Date May Change\" delay."
  },
  "86491:608:P": {
    stullerItem: "86491",
    productName: "Engravable Starburst Necklace",
    locations: [
      { id: "front", label: "Front", maxLength: 1 }
    ],
    engravingTypes: ["text", "handwritten"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Made To Order on Stuller — a 7-day Stuller lead time already applies to this piece, separate from and in addition to engraving's own \"Ship Date May Change\" delay."
  },
  "86491:609:P": {
    stullerItem: "86491",
    productName: "Engravable Starburst Necklace",
    locations: [
      { id: "front", label: "Front", maxLength: 1 }
    ],
    engravingTypes: ["text", "handwritten"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Made To Order on Stuller — a 7-day Stuller lead time already applies to this piece, separate from and in addition to engraving's own \"Ship Date May Change\" delay."
  },
  "88970:107:P": {
    stullerItem: "88970",
    productName: "Engravable Crescent Moon Pendant",
    locations: [
      { id: "front", label: "Front", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Laser engraving only."
  },
  "88970:109:P": {
    stullerItem: "88970",
    productName: "Engravable Crescent Moon Pendant",
    locations: [
      { id: "front", label: "Front", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Laser engraving only."
  },
  "88970:111:P": {
    stullerItem: "88970",
    productName: "Engravable Crescent Moon Pendant",
    locations: [
      { id: "front", label: "Front", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Laser engraving only."
  },
  "88970:112:P": {
    stullerItem: "88970",
    productName: "Engravable Crescent Moon Pendant",
    locations: [
      { id: "front", label: "Front", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Laser engraving only."
  },
  "88970:113:P": {
    stullerItem: "88970",
    productName: "Engravable Crescent Moon Pendant",
    locations: [
      { id: "front", label: "Front", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Laser engraving only."
  },
  "88970:LG102:P": {
    stullerItem: "88970",
    productName: "Engravable Crescent Moon Pendant",
    locations: [
      { id: "front", label: "Front", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Laser engraving only."
  },
  "88970:LG103:P": {
    stullerItem: "88970",
    productName: "Engravable Crescent Moon Pendant",
    locations: [
      { id: "front", label: "Front", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Laser engraving only."
  },
  "88970:LG106:P": {
    stullerItem: "88970",
    productName: "Engravable Crescent Moon Pendant",
    locations: [
      { id: "front", label: "Front", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Laser engraving only."
  },
  "88970:LG108:P": {
    stullerItem: "88970",
    productName: "Engravable Crescent Moon Pendant",
    locations: [
      { id: "front", label: "Front", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Laser engraving only."
  },
  "88970:LG114:P": {
    stullerItem: "88970",
    productName: "Engravable Crescent Moon Pendant",
    locations: [
      { id: "front", label: "Front", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Laser engraving only."
  },
  "88225:100:P": {
    stullerItem: "88225",
    productName: "Engravable Disc Charm/Pendant",
    locations: [
      { id: "front", label: "Front", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Laser engraving only. NEWLY MAPPED 2026-07-15 — this product went live this session with no prior config entry; settings pulled from the original confirmed Stuller research (Front only, 1 character, laser only, Bookman Old Style)."
  },
  "88225:101:P": {
    stullerItem: "88225",
    productName: "Engravable Disc Charm/Pendant",
    locations: [
      { id: "front", label: "Front", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Laser engraving only. NEWLY MAPPED 2026-07-15 — this product went live this session with no prior config entry; settings pulled from the original confirmed Stuller research (Front only, 1 character, laser only, Bookman Old Style)."
  },
  "88225:102:P": {
    stullerItem: "88225",
    productName: "Engravable Disc Charm/Pendant",
    locations: [
      { id: "front", label: "Front", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Laser engraving only. NEWLY MAPPED 2026-07-15 — this product went live this session with no prior config entry; settings pulled from the original confirmed Stuller research (Front only, 1 character, laser only, Bookman Old Style)."
  },
  "88225:103:P": {
    stullerItem: "88225",
    productName: "Engravable Disc Charm/Pendant",
    locations: [
      { id: "front", label: "Front", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Laser engraving only. NEWLY MAPPED 2026-07-15 — this product went live this session with no prior config entry; settings pulled from the original confirmed Stuller research (Front only, 1 character, laser only, Bookman Old Style)."
  },
  "88225:104:P": {
    stullerItem: "88225",
    productName: "Engravable Disc Charm/Pendant",
    locations: [
      { id: "front", label: "Front", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Laser engraving only. NEWLY MAPPED 2026-07-15 — this product went live this session with no prior config entry; settings pulled from the original confirmed Stuller research (Front only, 1 character, laser only, Bookman Old Style)."
  },
  "88225:106:P": {
    stullerItem: "88225",
    productName: "Engravable Disc Charm/Pendant",
    locations: [
      { id: "front", label: "Front", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Laser engraving only. NEWLY MAPPED 2026-07-15 — this product went live this session with no prior config entry; settings pulled from the original confirmed Stuller research (Front only, 1 character, laser only, Bookman Old Style)."
  },
  "88225:107:P": {
    stullerItem: "88225",
    productName: "Engravable Disc Charm/Pendant",
    locations: [
      { id: "front", label: "Front", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Laser engraving only. NEWLY MAPPED 2026-07-15 — this product went live this session with no prior config entry; settings pulled from the original confirmed Stuller research (Front only, 1 character, laser only, Bookman Old Style)."
  },
  "88225:108:P": {
    stullerItem: "88225",
    productName: "Engravable Disc Charm/Pendant",
    locations: [
      { id: "front", label: "Front", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Laser engraving only. NEWLY MAPPED 2026-07-15 — this product went live this session with no prior config entry; settings pulled from the original confirmed Stuller research (Front only, 1 character, laser only, Bookman Old Style)."
  },
  "88225:109:P": {
    stullerItem: "88225",
    productName: "Engravable Disc Charm/Pendant",
    locations: [
      { id: "front", label: "Front", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Laser engraving only. NEWLY MAPPED 2026-07-15 — this product went live this session with no prior config entry; settings pulled from the original confirmed Stuller research (Front only, 1 character, laser only, Bookman Old Style)."
  },
  "88225:110:P": {
    stullerItem: "88225",
    productName: "Engravable Disc Charm/Pendant",
    locations: [
      { id: "front", label: "Front", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Laser engraving only. NEWLY MAPPED 2026-07-15 — this product went live this session with no prior config entry; settings pulled from the original confirmed Stuller research (Front only, 1 character, laser only, Bookman Old Style)."
  },
  "88225:111:P": {
    stullerItem: "88225",
    productName: "Engravable Disc Charm/Pendant",
    locations: [
      { id: "front", label: "Front", maxLength: 1 }
    ],
    engravingTypes: ["text"],
    fonts: ["Bookman Old Style"],
    defaultFont: "Bookman Old Style",
    colors: ["None", "Black", "Blue", "Brown", "Green", "Pink", "Red"],
    defaultColor: "None",
    notes: "Laser engraving only. NEWLY MAPPED 2026-07-15 — this product went live this session with no prior config entry; settings pulled from the original confirmed Stuller research (Front only, 1 character, laser only, Bookman Old Style)."
  }
};